module.exports = __webpack_public_path__ + "static/img/banner-wx.83d5d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner-wx.jpg
// module id = 6CXM
// module chunks = 1